import { createGlobalStyle } from 'styled-components';
import { ThemeConfig } from 'antd/es/config-provider/context';
import { AliasToken } from 'antd/es/theme/interface';

export const GlobalStyle = createGlobalStyle``;

export const antdThemeToken: Partial<AliasToken> = {
  // SeedToken
  sizeStep: 4,
  sizeUnit: 4,
  borderRadius: 4,
  zIndexBase: 0,
  colorBgLayout: '#f8f8f8',
  colorBgBase: '#ffffff',
  colorError: '#ff2e52',
  colorInfo: '#00d0be',
  colorLink: '#00d0be',
  colorPrimary: '#00d0be',
  colorPrimaryText: '#00d0be',
  colorBorderSecondary: '#ededed',
  colorText: '#222222',
  colorTextBase: '#222222',
  colorWarning: '#faad14',
  controlHeight: 32,
  fontFamily: '"Nunito Sans","Open Sans",Arial,sans-serif',
  fontSize: 14,
  lineHeight: 1.42,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  fontSizeLG: 16,
  fontSizeSM: 12,
  fontSizeXL: 20,
  fontWeightStrong: 600,

  // AliasToken
  colorTextLightSolid: '#ffffff',

  sizeXXL: 48,
  sizeXL: 32,
  sizeLG: 24,
  sizeMD: 20,
  sizeMS: 16,
  size: 16,
  sizeSM: 12,
  sizeXS: 8,
  sizeXXS: 4,
  padding: 16,
  paddingMD: 20,
  paddingSM: 12,
  paddingXS: 8,
  paddingXXS: 4,
  paddingLG: 24,
  paddingXL: 32,
  margin: 16,
  marginSM: 12,
  marginXS: 8,
  marginXXS: 4,
  marginLG: 24,
  marginXL: 32,
  marginXXL: 48,
};

export const antdTheme: ThemeConfig = {
  token: antdThemeToken,
};
